import { PalstatDefaultButtonsProps } from "../../types/palstatDefaultButtonsProps";
import { useTranslation } from "react-i18next";
import { hideContextMenu } from "../../aplUtils/jqueryHelper";
export default function PalstatDefaultRightClick(props: PalstatDefaultButtonsProps) {
    const { t } = useTranslation();
    if (
        !props.options.palletDetails &&
        !props.options.block &&
        !props.options.unblock &&
        !props.options.reprint &&
        !props.options.scrap &&
        !props.options.delete &&
        !props.options.partPallet &&
        !props.options.copySscc
    )
        return <div id="contextMenu" className="ui-front"></div>;
    else
        return (
            <div id="contextMenu" className="ui-front" onClick={hideContextMenu}>
                <ul
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="dropdownMenu"
                    style={{ display: "block", position: "static", marginBottom: "5px" }}
                >
                    {props.options.palletDetails ? (
                        <li>
                            <div id="dropdownMenuPltStat" className="dropdown-item" onClick={props.options.palletDetailsClick}>
                                {t("main.palletDetail")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.block ? (
                        <li>
                            <div id="dropdownMenuBlock" className="dropdown-item" onClick={props.options.blockClick}>
                                {t("main.block")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.unblock ? (
                        <li>
                            <div id="dropdownMenuUnblock" className="dropdown-item" onClick={props.options.unblockClick}>
                                {t("main.unblock")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.reprint ? (
                        <li>
                            <div id="dropdownMenuReprint" className="dropdown-item" onClick={props.options.reprintClick}>
                                {t("main.reprint")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.scrap && props.options.hideScrap !== true ? (
                        <li>
                            <div id="dropdownMenuScrap" className="dropdown-item" onClick={props.options.scrapClick}>
                                {t("main.scrap")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.delete ? (
                        <li>
                            <div id="dropdownMenuDelete" className="dropdown-item" onClick={props.options.deleteClick}>
                                {t("main.delete")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.partPallet ? (
                        <li>
                            <div id="dropdownMenuPartPallet" className="dropdown-item" onClick={props.options.partPalletClick}>
                                {t("main.partPallet")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.copySscc ? (
                        <li>
                            <div id="dropdownMenuCopySSSC" className="dropdown-item" onClick={props.options.copySsccClick}>
                                {t("main.copySscc")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                </ul>
            </div>
        );
}
